import { FigureVarSettingsDto, isFigureVarSettingsDto } from "./FigureVarSettingsDto";

/**
 * Defines the settings for reference lines within a figure.
 */
export interface FigureReferenceLinesSettingsDto {
  parameters?: FigureVarSettingsDto[];
}

/**
 * Type guard to check if an object is a FigureReferenceLinesSettingsDto value.
 *
 * @param obj - The object to check.
 * @returns True when the value matches the reference line settings shape.
 */
export const isFigureReferenceLinesSettingsDto = (
  obj: unknown,
): obj is FigureReferenceLinesSettingsDto => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureReferenceLinesSettingsDto;
  if (chkObj.parameters !== undefined && !Array.isArray(chkObj.parameters)) {
    return false;
  }
  if (
    Array.isArray(chkObj.parameters) &&
    chkObj.parameters.some((parameter) => !isFigureVarSettingsDto(parameter))
  ) {
    return false;
  }
  return true;
};
